export default "__VITE_ASSET__bb315e6b__"